import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'companieAllow',
    pure: false
})
export class PipeCompanieAllow implements PipeTransform {
    transform(items: any[], owner: any): any {
        return items?.filter(item => {
            return item.company_person_id == owner?.personId || item.company_person_id == owner?.company_person_id || item.company_person_id == owner?.owner_person_id || item.company_perfil_id == '6';
        });
    }
} 